import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/ad-image.constant";

export {
    saveSingleAdImage,
    addAdImages,
    addSingleAdImage,
    updateSingleAdImage,
    getSingleAdImage,
    searchAdImages,
    searchAdImagesWithSearchCriteria,
    prepareAdImagesList
}

const collectionName = 'ad-images';
const collectionReference = collection(fireStoreDB, collectionName);

const saveSingleAdImage = (adImage) => {
    const documentReference = doc(fireStoreDB, collectionName, adImage.id);

    adImage.updatedAt = new Date();
    if (!adImage.createdAt) {
        adImage.createdAt = adImage.updatedAt;
    }

    return setDoc(documentReference, adImage, {merge: true});
}

const addAdImages = (adImages) => {
    return Promise.map(adImages, async adImage => {
        await addSingleAdImage(adImage);
    });
}

const addSingleAdImage = (adImage) => {
    adImage.createdAt = new Date();
    adImage.updatedAt = adImage.createdAt;
    return addDoc(collectionReference, adImage);
}

const updateSingleAdImage = (adImage) => {
    console.log('updateSingleAdImage', adImage);

    const documentReference = doc(fireStoreDB, collectionName, adImage.id);
    adImage.updatedAt = new Date();
    return setDoc(documentReference, adImage);
}

const getSingleAdImage = async (adImageId) => {
    const documentReference = doc(fireStoreDB, collectionName, adImageId);
    const adImageDoc = await getDoc(documentReference);
    return prepareSingleAdImage(adImageDoc);
}

const searchAdImages = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const adImageResult = await getDocs(searchQuery);
    return prepareAdImagesList(adImageResult);
}

const searchAdImagesWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchAdImagesWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const adImageResult = await getDocs(searchQuery);
    return prepareAdImagesList(adImageResult);
}

const prepareAdImagesList = (adImageResult) => {
    const adImagesList = [];

    _.forEach(adImageResult.docs, adImageDoc => {
        adImagesList.push(prepareSingleAdImage(adImageDoc));
    });

    return adImagesList;
}


const prepareSingleAdImage = (adImageDoc) => {
    const adImage = adImageDoc.data();
    adImage.id = adImageDoc.id;
    return adImage;
}
